/** Facility View board size. The designer draws on an 800×600 board. */
export const STAGE_W = 800;
export const STAGE_H = 600;

export type StageShape = {
  shape?: string;
  x: number;
  y: number;
  width?: number;
  height?: number;
  radius?: number;
};

/**
 * Size the Facility View Konva stage for the measured canvas width.
 *
 * Wide screens keep the full 800px board width but only as tall as the drawn
 * shapes. Padding it out to 600px left a tall empty board that pushed the
 * drag tip and the distillery "Spirits containers" panel below the fold on a
 * landscape tablet after a page refresh (Todd, Nov 2 2026).
 * Narrow screens crop to the drawn shapes and scale that to fit.
 */
export function computeFacilityStageLayout(
  objects: StageShape[],
  canvasWidth: number
): { w: number; h: number; scale: number } {
  let maxX = 0;
  let maxY = 0;
  for (const o of objects) {
    const r = o.radius || 30;
    const right = o.shape === 'circle' ? o.x + Math.max(r, 40) : o.x + (o.width || 100);
    const bottom = o.shape === 'circle' ? o.y + r + 16 : o.y + (o.height || 60);
    maxX = Math.max(maxX, right);
    maxY = Math.max(maxY, bottom);
  }
  const contentW = Math.max(240, Math.ceil(maxX + 12));
  const contentH = Math.max(160, Math.ceil(maxY + 12));
  const avail = Math.max(120, canvasWidth - 24);
  if (avail >= STAGE_W) {
    // Empty design keeps the full board so the "No design objects found" note (y=300) shows.
    return { w: Math.max(STAGE_W, contentW), h: objects.length ? contentH : STAGE_H, scale: 1 };
  }
  const scale = Math.min(1, avail / contentW);
  return { w: contentW, h: contentH, scale };
}
